import HttpClient from "./index"
import ApiRoutes, { baseUrl } from "../config/endpoints"

export default class PnLBudgetAPI extends HttpClient {
  constructor() {
    super(baseUrl)
    this._initializeRequestInterceptor()
  }

  budgetData = ApiRoutes.pnlBudget.pnlBudgetData
  saveBudget = ApiRoutes.pnlBudget.saveBudgetData
  budgetYears = ApiRoutes.pnlBudget.budgetYears
  reportingYears = ApiRoutes.pnlBudget.reportingYears
  pnlReportingClasses = ApiRoutes.pnlBudget.pnlReportingClasses
  pnlReportingTable = ApiRoutes.pnlBudget.pnlReportingTable
  pnlReportingByLineItem = ApiRoutes.pnlBudget.pnlReportingByLineItem
  pnlTransactionData = ApiRoutes.pnlBudget.pnlTransactionData
  pnlBudgetClasses = ApiRoutes.pnlBudget.pnlBudgetClasses

  _initializeRequestInterceptor = () => {
    this.instance.interceptors.request.use(this._handleRequest)
  }

  _handleRequest = async (axiosConfig: any) => {
    return axiosConfig
  }

  getPnlBudget = (params: any) => {
    const { token, args } = params
    return this.instance({
      method: this.budgetData.Method,
      url: this.budgetData.EndPoint(args),
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
  }
  saveBudgetData = (params: any) => {
    const { token, payload } = params
    return this.instance({
      method: this.saveBudget.Method,
      url: this.saveBudget.EndPoint,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    })
  }

  getBudgetYears = (token: string) => {
    return this.instance({
      method: this.budgetYears.Method,
      url: this.budgetYears.EndPoint,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
  }
  getReportingYears = (token: string, groupSk: number) => {
    return this.instance({
      method: this.reportingYears.Method,
      url: this.reportingYears.EndPoint(groupSk),
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
  }
  // pnl reporting handlers
  getPnlClasses = (
    token: string,
    group_sk: any,
    year: any,
    month_list: any[],
  ) => {
    return this.instance({
      method: this.pnlReportingClasses.Method,
      url: this.pnlReportingClasses.EndPoint,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {
        group_sk: group_sk,
        year: year,
        month_list: month_list,
      },
    })
  }
  getPnlTableData = (token: string, data: any) => {
    return this.instance({
      method: this.pnlReportingTable.Method,
      url: this.pnlReportingTable.EndPoint,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data,
    })
  }

  getPnlTableDataByLineItem = (token: string, data: any) => {
    return this.instance({
      method: this.pnlReportingByLineItem.Method,
      url: this.pnlReportingByLineItem.EndPoint,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data,
    })
  }
  getPnlTransactionData = (token: string, data: any) => {
    return this.instance({
      method: this.pnlTransactionData.Method,
      url: this.pnlTransactionData.EndPoint,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data,
    })
  }

  getPnlBudgetClasses = (token: string, group_sk: any) => {
    return this.instance({
      method: this.pnlBudgetClasses.Method,
      url: this.pnlBudgetClasses.EndPoint(group_sk),
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
  }
}
